var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C14.746 0 12.095 2.604 12.008 5.838L8.338 11.084C8.06191 11.0298 7.78135 11.0017 7.5 11C6.552 11 5.674 11.298 4.947 11.8L0 9.845V15.222L3.105 16.45C3.32267 17.4543 3.87725 18.354 4.67668 18.9998C5.47612 19.6455 6.47235 19.9984 7.5 20C8.55151 19.998 9.56913 19.6279 10.3762 18.9538C11.1832 18.2797 11.7287 17.3443 11.918 16.31L17.691 11.984C17.794 11.99 17.896 12 18 12C21.309 12 24 9.309 24 6C24 2.691 21.309 0 18 0ZM18 2C20.206 2 22 3.794 22 6C22 8.206 20.206 10 18 10C15.794 10 14 8.206 14 6C14 3.794 15.794 2 18 2ZM18 3C17.2044 3 16.4413 3.31607 15.8787 3.87868C15.3161 4.44129 15 5.20435 15 6C15 6.79565 15.3161 7.55871 15.8787 8.12132C16.4413 8.68393 17.2044 9 18 9C18.7956 9 19.5587 8.68393 20.1213 8.12132C20.6839 7.55871 21 6.79565 21 6C21 5.20435 20.6839 4.44129 20.1213 3.87868C19.5587 3.31607 18.7956 3 18 3ZM7.5 12C9.43 12 11 13.57 11 15.5C11 17.43 9.43 19 7.5 19C6.82489 18.9988 6.16455 18.8023 5.59855 18.4343C5.03255 18.0664 4.58506 17.5425 4.31 16.926L6.58 17.824C6.882 17.944 7.192 18.002 7.498 18.002C8.08061 18.0033 8.64538 17.8011 9.09476 17.4303C9.54415 17.0595 9.84991 16.5434 9.95924 15.9711C10.0686 15.3989 9.9746 14.8064 9.69356 14.2961C9.41252 13.7857 8.96206 13.3896 8.42 13.176L6.143 12.273C6.5725 12.0921 7.03396 11.9993 7.5 12Z",
    fill: "url(#paint0_linear_344_1018)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_344_1018",
    x1: -5.67742,
    y1: 20,
    x2: 52.9677,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3333FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteam);
export default __webpack_public_path__ + "static/media/steam.db8c0d3ff6bd06f591b361aef5b0b5a1.svg";
export { ForwardRef as ReactComponent };